import styled from "@emotion/styled";
import { theme } from "@xometry/xometry_loft";

export const Container = styled.div`
  align-items: stretch;
  background-color: white;
  color: ${theme.colors.darkBlues[90]};
  display: flex;
  flex-direction: column;
  height: 60px;
  line-height: ${theme.lineHeights[4]};
  position: fixed;
  width: 100%;
  z-index: 101;
`;
